import {HttpErrorResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit,TemplateRef,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {BsModalService,ModalDirective} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {SERVER_API_URL} from 'src/app/app.constants';
import {CertificateMySuffixService} from 'src/app/client/certificate/certicate-my-suffix.service';
import {Principal} from 'src/app/core';
import {StateStorageService} from 'src/app/core/auth/state-storage.service';
import {ClauseExtensionMySuffixService} from 'src/app/entities/clause-extension-my-suffix';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {TdisConstants} from 'src/app/shared/constants/tdis-constants';
import {IClientDTO} from 'src/app/shared/model/client.model';
import {DownloadClauseExtesnion} from 'src/app/shared/model/download-clause-extension.model';
import {VesselUnknownDTO} from 'src/app/shared/model/one-time-scope-change-t-and-c.model';
import {RouterExtService} from 'src/app/shared/router-ext-service';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {TdisAlertService} from 'src/app/shared/services/tdis-alert-service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {currenyMaskService} from '../../shared/currencyMask.service';
import {VesselInformationMySuffixService} from '../vessel-information-my-suffix';
import {CountryMySuffixService} from './../country-my-suffix/country-my-suffix.service';
import {BulkDeclarationService} from './bulk-declaration.service';
declare let $: any;


@Component({
  selector: 'jhi-bulk-declaration-summary',
  templateUrl: './bulk-declaration-summary.component.html'
})
export class BulkDeclarationSummaryComponent implements OnInit ,OnDestroy{
  @ViewChild("cancelCerificateModal") cancelCerificateModal: ModalDirective;
  @ViewChild("rejectConfirmModel") rejectConfirmModel: ModalDirective;
  @ViewChild("confirmCerificateModal") confirmCerificateModal: ModalDirective;

  @ViewChild("childModal") childModal: ModalDirective;
  @ViewChild("lcTextModal") lcTextModal: ModalDirective;
  @ViewChild("approvalModal") approvalModal: ModalDirective;
  @ViewChild("ruleFailedModal") ruleFailedModal: ModalDirective;
  @ViewChild("revisedConfirmModel") revisedConfirmModel: ModalDirective;
  @ViewChild("lcApproveModal") lcApproveModal: ModalDirective;
  @ViewChild("vesselNameModal") vesselNameModal: ModalDirective;
  @ViewChild("vesselNameNotProvidedModal") vesselNameNotProvidedModal: ModalDirective;
  @ViewChild("vesselNameImoModal") vesselNameImoModal: ModalDirective;
  @ViewChild("vesselNameDataModal") vesselNameDataModal: ModalDirective;
  @ViewChild("vesselNameImoWarningModal") vesselNameImoWarningModal: ModalDirective;
  uncheckableRadioModel = "O_C_C";

  vesselUnknownDto: VesselUnknownDTO=new VesselUnknownDTO();
  readonly TdisConstants = TdisConstants;
  public readonly RoleUtil = RoleUtil;

  modalRef: BsModalRef;
  private resourceUrl = SERVER_API_URL + "api/";
  showConfirmIMO = true;
  lawsCheck = false;
  printPremiumPaid = false;
  favourite = false;
  cargoList = [];
  vesselImoNumber = "";
  showSpinner = false;
  showCheck = false;
  totalRule: any;
  failedRule: any;
  successRule: any;
  noTaxValue = 0;
  lcTextLength = 0;
  isVesselSubRulePassed: boolean;

  cargoSettings = {
    singleSelection: true,
    text: "Select Cargo",
    enableSearchFilter: true,
    classes: "myclass custom-class",
    closeDropDownOnSelection: true,
    defaultOpen:false
  };
  selectedItems = [];

  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  clientInfo: IClientDTO;

  sumInsured: any;
  clientSumInsured: any;
  finalRate: any;
  warStrikePremiumRate: any;
  overagePremiumRate: any;
  premiumRateValue: any;
  netPremium: any;
  subTotalValue: any;
  taxesValue: any;
  totalValue: any;
  co2wtwValue: any;
  enablePolicyEsgAwareness: boolean=false;
  lcApproved: boolean = false;
  rebateSubtotalValue: any;
  rebateTaxValue: any;
  rebateRate: any;
  // isVesselName: boolean = true;
  loadingList = [];
  loadingSettings = {};
  selectedLoadingItems = [];

  clauseIdArray = [];
  extensionIdArray = [];

  dischargeList = [];
  selectedDischargeItems = [];
  dischargeSettings = {};

  certificateRequestId: number;
  certificateCommonNumber: number;

  scopeId: number;
  summaryDetails: any;
  shipemntDate: any;
  lcApproval: boolean;
  downloadObj = {
    scopeId: null,
    certificateRequestId: null,
    certificateFileType: ""
  };

  rejectionReason: string;
  status: string;
  actionDisabled = false;

  isCertificatedDownloaded = false;
  isInvoiceDownloaded = false;
  isCertificatedCancelled = false;
  isQuotationConfirmed = false;
  lcChecked: boolean = false;
  lcText: string;
  isGetCertificateEnabled: boolean = false;
  isLCEnabled: boolean = false;
  showCertificateBasedOnImoNumber = false;
  netPremiumRebate: boolean = null;


  // additionalPremium
  additionalPremium: number;
  additionalPremiumRateValue: any;

  clientWithPendingManualApproval = false;

  ratePrecisionOptions: any;

  isLoading = false;
  pdfPath = null;
  showReviceCertificateOption: boolean = false;
  invoiceRequestId: any;

  isShowConfirmButton: boolean = false;
  isShowRejectButton: boolean = false;
  isShowCancelButton: boolean = false;
  isShowReviseButton: boolean = false;
  isShowAdditionalPremiumRate: boolean;
  isOpenRequest: any;
  esgAwarenessValue: any;
  isAutoQuotation=false;
  vesselImoOrNameOrUnknownValue: string = "name";
  isAnyRuleApprovedManually=false;

  constructor(
    private jhiAlertService: JhiAlertService,
    private modalService: BsModalService,
    private certificateService: CertificateMySuffixService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    // private principal: Principal,
    public principal: Principal,
    private stateStorageService: StateStorageService,
    private currenyMask: currenyMaskService,
    private clauseExtensionMySuffixService: ClauseExtensionMySuffixService,
    private bulkDeclarationService: BulkDeclarationService,
    private routerExtService: RouterExtService,
    private languageChangeService: LanguageChangeService,
    private countryService: CountryMySuffixService,
    private toastr: TdisAlertService,
    private vesselInformationMySuffixService: VesselInformationMySuffixService
  ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
   }

  previousState() {
    if( this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.PENDING_MANUAL_APPROVAL || this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.PENDING_CERTIFICATE_CONFIRMATION){
      this.router.navigate(['/my-declaration/pending']);
    }else if(this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.DECLARED){
      this.router.navigate(['/my-declaration/declared']);
    }else if(this.summaryDetails.certificateRequestScopeStatus ===  TdisConstants.CertificateRequestScopeStatus.REQUEST_FAILED || this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.REJECTED || this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.CERTIFICATE_CANCELLED){
      this.router.navigate(['/my-declaration/rejected']);
    }
    
   // window.history.back();
  }
  typeOfRequest:any;
  ngOnInit() {
    this.checkForVoyegaNumberEnabled();
    let url = this.routerExtService.getPreviousUrl();
    console.log('previous urlllllllllllll', url);
    this.checkPremiumCalculationPermission()
    this.certificateRequestId = this.activatedRoute.snapshot.params.certificateRequestId;
    this.isOpenRequest = this.activatedRoute.snapshot.params.isOpenRequest;
    console.log(' &&&&&&&&&&&& ', this.certificateRequestId);
    console.log(' ######### ', this.isOpenRequest);

    console.log(JSON.parse(localStorage.getItem("typeOfRequest")))
    this.typeOfRequest = JSON.parse(localStorage.getItem("typeOfRequest"));
    if(this.typeOfRequest== "SPECIFIC"){
      this.isOpenRequest = false;
    }
    else{
      this.isOpenRequest = this.activatedRoute.snapshot.params.isOpenRequest;
      localStorage.removeItem("typeOfRequest");
      console.log(JSON.parse(localStorage.getItem("typeOfRequest")))
    }

    if (this.certificateRequestId) {

      localStorage.removeItem("certificateRequestId");
      localStorage.setItem('certificateRequestId', JSON.stringify(this.certificateRequestId));
      this.isVesselInformationSubRulePassed(this.certificateRequestId);
      console.log(' ######### ', this.certificateRequestId);
    } else {
      localStorage.removeItem("certificateRequestId");
    }

    this.favourite = JSON.parse(localStorage.getItem('favourite'));
    console.log(' ######### this.favourite ', this.favourite);

    this.scopeId = this.activatedRoute.snapshot.params.scopeId;

    //     this.isCertificatedDownloaded = JSON.parse(this.activatedRoute.snapshot.params.isCertificatedDownloaded);
    this.downloadObj.scopeId = this.scopeId;
    this.downloadObj.certificateRequestId = this.certificateRequestId;

    // get certificate details data
    this.getCertificateData();
    this.cleanData();
    //if(this.isOpenRequest == 'false'){
      // this.ruleFaileDetail();
    //}
   
    this.ratePrecisionOptions = this.currenyMask.ratePrecisionOptions;

    //this.netPremiumRebate = this.summaryDetails.netPremiumRebate;


    if (this.principal.staffPermission) {
      if (this.principal.staffPermission.certificate) {
        this.showReviceCertificateOption = true;
      } else {
        this.showReviceCertificateOption = false
      }
    }

    this.checkForVesselNameOrImoMandatoryEnabled();


  }

  get authority() {
    if (this.principal.userIdentity) {
        return this.principal.userIdentity.authorities[0];
    }
  }

  showButtons() {
    this.isShowConfirmButton = false;
    if (this.principal.hasAnyAuthorityDirect(RoleUtil.BrokerUnderwriteInsurerAuthorities) &&
      (this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.PENDING_CERTIFICATE_CONFIRMATION || this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.VESSEL_TBA)) {
      this.isShowConfirmButton = true;
    } else if (this.principal.hasAnyAuthorityDirect(RoleUtil.ClientAuthorities) &&
    (this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.PENDING_CERTIFICATE_CONFIRMATION || this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.VESSEL_TBA)) {
      if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveynace == 'Vessel'){
        if(this.summaryDetails && this.summaryDetails.certificateRequestDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isImoAvailable) {
          this.isShowConfirmButton = true;
        } else if (this.summaryDetails && this.summaryDetails.certificateRequestDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory) {
          this.isShowConfirmButton = true;
        }
      }else{
        this.isShowConfirmButton = true;
      }
    }

    this.isShowRejectButton = false;
    if (this.principal.hasAnyAuthorityDirect(RoleUtil.BrokerUnderwriteInsurerAuthorities) &&
      this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.PENDING_MANUAL_APPROVAL) {
      this.isShowRejectButton = true;
    }

    this.isShowReviseButton = false;
    if (this.principal.hasAnyAuthorityDirect(RoleUtil.ClientAuthorities) &&
      this.isQuotationConfirmed && !this.isCertificatedCancelled) {
      this.isShowReviseButton = true;
    }

    this.isShowCancelButton = false;
    if (this.principal.hasAnyAuthorityDirect(RoleUtil.ClientBrokerUnderwriterInsurerAuthorities) &&
      this.isQuotationConfirmed && !this.isCertificatedCancelled) {
      this.isShowCancelButton = true;
      this.isShowReviseButton = true;
    }
  }

  ngOnDestroy(): void {
    console.log('DESTROYED SUCCESSFULY...........');
     this.jhiAlertService.clear();
  }

  getPermissionsCheck() {
    const loggedinUserPermissions = this.principal.userIdentity.authorities[0];
    const allowedPermissions = [
      "BROKER",
      "BROKER_STAFF",
      "AUDIT_USER_STAFF",
      "AUDIT_USER",
      "UNDERWRITER",
      "UNDERWRITER_STAFF",
      "INSURER",
      "INSURER_STAFF"
    ];
    return allowedPermissions.indexOf(loggedinUserPermissions) >= 0;
  }

  ngAfterViewInit() {
    // if( this.ruleFailedModal){
    //   this.ruleFailedModal.hide();
    // }
   
  }

  isVesselNameAddedManually: boolean;
  isVesselRuleFailed: boolean;
  ruleFaileDetail() {
    let url = "api/bulk-certificate-manual-requests/" + this.certificateRequestId;
    this.bulkDeclarationService.getById(url).subscribe(res => {
      console.log("rulefailed data..", res);
      this.isVesselNameAddedManually = res.isVesselNameAddedManually;
      this.isVesselRuleFailed = res.isVesselRuleFailed;
      this.failedRule = res.failedRules ? res.failedRules : 0;
      this.successRule = res.successRules ? res.successRules : 0;
      this.totalRule=res.totalRules? res.totalRules:0;
      this.isAutoQuotation=res.isAutoQuotation;

      if(this.isVesselNameOrImoMandatoryEnabled && this.failedRule == 0 && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselUnknown &&  this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.displayImoNumber === 'NA' && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.displayVesselName === 'NA' && this.isAutoQuotation) {
        this.showVesselNameImoWarningModal();
      } else if(!this.isVesselNameOrImoMandatoryEnabled && this.failedRule == 0 && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselUnknown && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName && this.isAutoQuotation) {
        this.showVesselNameImoWarningModal();
      }

      this.isAnyRuleApprovedManually=res.certificateRules.some(r => r.isApproved==true);
      
    });
  }
  // method getCertificateData

  certificateScopeId: any;

  getCertificateData() {
    let url

      if(this.isOpenRequest == 'true'){
        url =
      "api/open-bulk-certificate-requests/" +
      this.certificateRequestId +
      "/scopes/" +
      this.scopeId;
      }else{
        url =
        "api/bulk-certificate-requests/" +
        this.certificateRequestId +
        "/scopes/" +
        this.scopeId;
      }
      
    this.bulkDeclarationService.getById(url).subscribe(res => {
      this.summaryDetails = res.payload;
      if(this.summaryDetails && this.summaryDetails.certificateRequestDTO  && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO){
        let certificteRequestDto = this.summaryDetails.certificateRequestDTO;
        let shipmentDetailsDTO = certificteRequestDto.shipmentDetailsDTO;

        if(shipmentDetailsDTO.meansOfConveyanceNumber && shipmentDetailsDTO.vesselName){
          this.vesselImoOrNameOrUnknownValue = "name";
        }else if(certificteRequestDto.isFirstClassVessel){
          this.vesselImoOrNameOrUnknownValue = "unknown";
        }else if(shipmentDetailsDTO.meansOfConveyanceNumber){
          this.vesselImoOrNameOrUnknownValue = "imo";
        }else if(shipmentDetailsDTO.vesselName){
          this.vesselImoOrNameOrUnknownValue = "name";
        }

      }
      if(!this.summaryDetails.additionalPremiumRate) {
        this.summaryDetails.additionalPremiumRate = 0;
      }
      this.ruleFaileDetail();
      this.setSummaryDetails(res);
      this.getState();
    });
  }

  noValue: string = '';
  setSummaryDetails(res) {
    this.certificateScopeId = res.payload.id
    if (this.summaryDetails.draftCertificate) {
      let data = "data:application/pdf;base64," + this.summaryDetails.draftCertificate.preview;
      this.pdfPath = data;
    }
    this.certificateCommonNumber = res.payload.certificateCommonNumber;
    if (this.certificateCommonNumber) {
      localStorage.removeItem("certificateCommonNumber");
      localStorage.setItem('certificateCommonNumber', JSON.stringify(this.certificateCommonNumber));
    } else {
      if (JSON.parse(localStorage.getItem('certificateCommonNumber'))) {
        localStorage.removeItem("certificateCommonNumber");
      }
    }

    this.showCertificateBasedOnImoNumber =
      res.payload.certificateRequestDTO.shipmentDetailsDTO.isImoAvailable;
    if (
      res.payload.certificateRequestDTO.shipmentDetailsDTO
        .meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL
    ) {
      if (
        res.payload.certificateRequestDTO.shipmentDetailsDTO.isImoAvailable
      ) {
        this.showCertificateBasedOnImoNumber = true;
      } else {
        this.showCertificateBasedOnImoNumber = false;
      }
    } else {
      this.showCertificateBasedOnImoNumber = true;
    }
    if (this.totalRule !== 0 && this.totalRule == 9) {
      this.showCertificateBasedOnImoNumber = true;

    }
    this.shipemntDate= res.payload.certificateRequestDTO.shipmentDetailsDTO.dateOfShipment;
    this.premiumRateValue = res.payload.premiumRateValue;
    this.netPremium = res.payload.netPremium;
    this.subTotalValue = res.payload.subTotal;
    this.rebateSubtotalValue = res.payload.rebateSubTotalValue;
    this.taxesValue = res.payload.taxes;
    this.rebateTaxValue = res.payload.rebateTaxValue;
    this.totalValue = res.payload.totalAmount;
    this.co2wtwValue = res.payload.co2wtwValue;
    if(!this.co2wtwValue) {
      this.noValue = 'N/A';
    }
    this.enablePolicyEsgAwareness = res.payload.enablePolicyEsgAwareness;
    this.rebateRate = this.summaryDetails.rebatePercent;
    this.clientSumInsured =
      res.payload.certificateRequestDTO.cargoDetailsDTO.sumInsured;
    this.sumInsured =
      res.payload.certificateRequestDTO.cargoDetailsDTO.sumInsuredInPolicyCurrency;

    this.finalRate = this.clientSumInsured / this.sumInsured;
    this.warStrikePremiumRate = (
      this.sumInsured *
      (res.payload.warStrikePremiumRate / 100)
    ).toFixed(2);
    this.overagePremiumRate = (
      this.sumInsured *
      (res.payload.overagePremiumRate / 100)
    ).toFixed(2);

   
    if (res.payload.additionalPremiumRate != null && res.payload.additionalPremiumRate>0) {
      this.additionalPremiumRateValue = (
        this.sumInsured *
        (res.payload.additionalPremiumRate / 100)
      ).toFixed(2);
    }else{
      this.additionalPremiumRateValue =0.0;
    }

    if (
      this.summaryDetails &&
      this.summaryDetails.certificateRequestScopeStatus ===
      "PENDING_MANUAL_APPROVAL"
    ) {
      if (this.getPermissionsCheck()) {
          this.ruleFailMessageg();
       
      }
    }
    this.lcApproval = res.payload.lcApproval;

    this.isShowAdditionalPremiumRate = false;
    if (((this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.PENDING_CERTIFICATE_CONFIRMATION || this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.PENDING_MANUAL_APPROVAL) || (this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.DECLARED) || (this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.CERTIFICATE_CANCELLED) || (this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.VESSEL_TBA)) && res.payload.additionalPremiumRate != null) {
      this.isShowAdditionalPremiumRate = true;
    }

    if(this.summaryDetails.certificateRequestScopeStatus===TdisConstants.CertificateRequestScopeStatus.PENDING_MANUAL_APPROVAL) {
      this.isVesselInformationSubRulePassed(this.certificateRequestId);
    }

    this.checkStatus(); // status check for downlodbutton/get certificate button show/hide
  }

  calculateTaxes() { }

  checkStatus() {
    // showing download button status = certificate
    // if (this.summaryDetails.certificateRequestScopeStatus === "CERTIFICATE") {
    if (this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.DECLARED) {
      this.isCertificatedDownloaded = true;
      this.isCertificatedCancelled = false;
      this.isQuotationConfirmed = true;
      if (this.summaryDetails.invoiceId) {
        this.isInvoiceDownloaded = true;
      }
    } else if (
      this.summaryDetails.certificateRequestScopeStatus ===
      TdisConstants.CertificateRequestScopeStatus.CERTIFICATE_CANCELLED
    ) {
      this.isCertificatedDownloaded = true;
      this.isCertificatedCancelled = true;
      if (this.summaryDetails.invoiceId) {
        this.isInvoiceDownloaded = true;
      }
    } else {
      this.isCertificatedDownloaded = false;
      this.isCertificatedCancelled = false;
    }

    if (
      (this.summaryDetails.certificateRequestScopeStatus ===
        TdisConstants.CertificateRequestScopeStatus.PENDING_MANUAL_APPROVAL &&
        (this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT ||
          this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT_STAFF))
      || this.summaryDetails.certificateRequestScopeStatus ===
      TdisConstants.CertificateRequestScopeStatus.CANCELLED
    ) {
      this.clientWithPendingManualApproval = true;
    } else {
      this.clientWithPendingManualApproval = false;
    }

    if (
      (this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.REQUEST_FAILED ||
        this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.REJECTED) &&
      (this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT ||
        this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT_STAFF)
    ) {
      this.actionDisabled = true;
    } else {
      this.actionDisabled = false;
    }

    // get certificate enable/disable
    if (
      this.summaryDetails.certificateRequestScopeStatus === TdisConstants.CertificateRequestScopeStatus.APPROVED ||
      this.summaryDetails.certificateRequestScopeStatus ===
      TdisConstants.CertificateRequestScopeStatus.PENDING_CERTIFICATE_CONFIRMATION
    ) {
      this.isGetCertificateEnabled = true;
    }
    if (
      this.summaryDetails.certificateRequestScopeStatus ===
      TdisConstants.CertificateRequestScopeStatus.PENDING_CERTIFICATE_CONFIRMATION
    ) {
      this.isLCEnabled = true;
    }
    if (
      this.summaryDetails.certificateRequestScopeStatus ===
      TdisConstants.CertificateRequestScopeStatus.LC_PENDING_APPROVAL
    ) {
      this.isGetCertificateEnabled = false;
    }

    this.showButtons();
  }
  onCargoSelect(event: any) { }

  onLoadingSelect(event: any) { }

  onDischargeSelect(event: any) { }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "material-custom-modal" })
    );
  }

  downloadCertificate() {
    let printPremiumValue = "view";
    if (this.printPremiumPaid) {
      printPremiumValue = "views";
    }

    const _URL =
      this.resourceUrl +
      "download-certificate/" +
      this.downloadObj.certificateRequestId;
    this.certificateService.queryWithURL(_URL).subscribe(res => {
      console.log(res);
      let headersData = res.headers.get("content-type");
      let fileName = res.headers.get("file-name");
      let file = new Blob([res.body], { type: headersData });
      let fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      this.pdfPath = fileURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      //  window.URL.revokeObjectURL(fileURL);
      document.body.removeChild(link);
    });

    this.childModal.hide();
    // window.open(URL);
    if (!this.isCertificatedDownloaded) {
      this.router.navigateByUrl("/certificate/my-certificate");
    }
  }



  downloadInvoice() {
    if (!this.invoiceRequestId) {
      this.invoiceRequestId = this.summaryDetails.invoiceId;
    }

    const _URL =
      this.resourceUrl +
      "download-invoice/" +
      this.invoiceRequestId;
    this.certificateService.queryWithURL(_URL).subscribe(res => {
      console.log(res);
      let headersData = res.headers.get("content-type");
      let fileName = res.headers.get("file-name");
      let file = new Blob([res.body], { type: headersData });
      let fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      // this.pdfPath = fileURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      //  window.URL.revokeObjectURL(fileURL);
      document.body.removeChild(link);
    });

    this.childModal.hide();
    // window.open(URL);
    if (!this.isCertificatedDownloaded) {
      this.router.navigateByUrl("/certificate/my-certificate");
    }
  }

  /* certificate confirmation based on the certificateRequestId,
     printPremiumValue and certificateFileType */

  confirmCertificate() {
    let printPremiumValue = "view";
    if (this.printPremiumPaid) {
      printPremiumValue = "views";
    }
    const URL =
      this.resourceUrl +
      "confirm-quotation/" +
      this.downloadObj.certificateRequestId +
      "/" +
      printPremiumValue +
      "/" +
      this.downloadObj.certificateFileType;
    this.childModal.hide();
    this.isLoading = true;
    this.certificateService.getConfirmCertificate(URL).subscribe(res => {
      if (res.body.payload) {
        if (res.body.payload.uploadStatus === 'PENDING_UPLOAD') {
          if (res.body.payload.certificateNumber) {
            localStorage.removeItem("certificateCommonNumber");
            localStorage.setItem('certificateCommonNumber', JSON.stringify(res.body.payload.certificateNumber));
          }


          //  if(res.body.payload.loggedInRole === 'BROKER' || res.body.payload.loggedInRole === 'BROKER_STAFF'){
          this.router.navigateByUrl('broker-upload-certificate');
          // }else{
          //   this.router.navigateByUrl('provisional-client-info');
          // } 
        }
      }
      if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
        this.isCertificatedDownloaded = true;
        console.log("Invoice Body", res.body);

        if (res.body.payload) {
          this.isInvoiceDownloaded = true;
          this.invoiceRequestId = res.body.payload;
          console.log("this.invoiceRequestId", this.invoiceRequestId);
        }
        this.isQuotationConfirmed = true;
        this.downloadCertificate();
        window.scroll(0, 0);
        this.jhiAlertService.success(res.body.message);
        this.isLoading = false;
      } else {
        this.isLoading = false;
      }
    });
  }

  /* cancel Certificate realted methods starts */

  cancelCerificateModalOpen() {
    this.cancelCerificateModal.show();
  }
  cancelCerificateModalhide() {
    this.cancelCerificateModal.hide();
  }

  // cancelCertificate() {
  //   const URL =
  //     this.resourceUrl +
  //     "cancel-certificate/" +
  //     this.downloadObj.certificateRequestId +
  //     "/false";
  //   this.certificateService.getCancelCertificate(URL).subscribe(res => {
  //     if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
  //       this.cancelCerificateModal.hide();
  //       this.jhiAlertService.success(
  //         "Cancelled Certificate Successfully",
  //         null,
  //         null
  //       );
  //       this.isCertificatedCancelled = true;
  //     } else {
  //       this.isCertificatedCancelled = false;
  //     }
  //   });
  // }

  /* cancel Certificate realted methods starts */

  cleanData() {
    localStorage.removeItem("tradeDetails");
    localStorage.removeItem("cargoDetail");
    localStorage.removeItem("shippingDetail");
    localStorage.removeItem("scopeList");
  }

  showChildModal(): void {
    this.isLoading = true;
    this.childModal.show();
  }
  hideChildModal(): void {
    this.childModal.hide();
    this.isLoading = false;
  }

  showApprovalModal(requestId) {
    this.approvalModal.show();
  }
  hideApprovalModal() {
    this.approvalModal.hide();
  }

  // confirnm approval

  confirmApproval() {
    if (this.status == "APPROVED") {
      this.rejectionReason = "";
    }
    const data = {
      certificateRequestId: this.summaryDetails.id,
      status: this.status,
      rejectionReason: this.rejectionReason
    };
    let url = this.resourceUrl + "certificate-requests/update-status";
    this.certificateService.postData(data, url).subscribe(res => {
      this.summaryDetails.certificateRequestScopeStatus = this.status;
      this.hideApprovalModal();
      console.log(res);
      console.log(res.body);
      console.log(res.message);
      this.summaryDetails.rejectionReason = this.rejectionReason;
      this.checkStatus(); // status check for downlodbutton/get certificate button show/hide
    });
  }

  // sending  Additional PremiumRate

  isVesselNameAlreadyAddedToRequest : boolean = false;
  wrongImoErrorMessage: string = null;
  sendAdditionalPremiumRate() {

    if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselUnknown){

      if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isImoAvailable){
        this.isVesselNameAlreadyAddedToRequest = true;
      }else{
        this.isVesselNameAlreadyAddedToRequest = false;
      }
    }

    const apiUrl = this.resourceUrl + "bulk-save-manual-quotation";
    if (this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveynace===TdisConstants.MeansOfConveyance.VESSEL && !this.isVesselSubRulePassed && !this.isVesselNameAlreadyAddedToRequest && !this.isVesselNameAddedManually){
      if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselUnknown) {
        // wishlist box
        this.addVesselNameImo();
      } else {
        // normal free text box
        this.vesselNameModal.show();
      }
      // this.isVesselName = false;
      this.isVesselSubRulePassed = true;
      return;
    } else {
      this.vesselNameModal.hide();
      // for wishlist popup
      // if(this.vesselNameImoModal) {
      //   this.vesselNameImoModal.hide();
      // }
      
      $(document.body).removeClass("modal-open");
    }


    if(this.summaryDetails.certificateRequestDTO.isFirstClassVessel) {
      console.warn('test');
      this.hideVesselNameImoModal();
    }
    if(this.isPremiumCalculationDisable){
      this.summaryDetails.additionalPremiumRate =0.0;
    }
    this.bulkDeclarationService
      .postData(this.summaryDetails, apiUrl)
      .subscribe(res => {
        this.clearWrongImoMsg();
        
        // for wishlist popup
        this.vesselNameImoModal.hide();
        $(document.body).removeClass("modal-open");
        this.summaryDetails = res.body.payload;
        this.setSummaryDetails(res.body);
        this.getCertificateData();
        // this.ruleFaileDetail();
      },err => {
        // this.isVesselSubRulePassed=false;
        this.wrongImoErrorMessage = err.error.message;
        // this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
        // console.warn(this.wrongImoErrorMessage);
      });

  }

  getVeseelName_ImoNumber(shipmentDetails) {
    if (shipmentDetails) {
      // let vesselName = (shipmentDetails.vesselName) ? (shipmentDetails.vesselName) : 'NA';
      let vesselName=shipmentDetails.displayVesselName;
      // let vesselIMONumber = (shipmentDetails.meansOfConveyanceNumber) ? (shipmentDetails.meansOfConveyanceNumber) : 'NA';
      let vesselIMONumber=shipmentDetails.displayImoNumber;
      // let finalString = vesselName + " / " + vesselIMONumber;

      let finalString: string = "";
      if(vesselName && vesselName === TdisConstants.VesselName.FIRST_CLASS_VESSEL) {
        finalString = vesselName;
      } else {
        finalString = vesselName+" / "+vesselIMONumber;
      }

      return finalString;

    } else {
      return;
    }
  }
  calculateAdditionPremium(event) {
    let additionalPremiumRate = event.target.value.replace(/[,.]/g, function (
      m
    ) {
      // m is the match found in the string
      // If `,` is matched return `.`, if `.` matched return `,`
      return m === "." ? "" : ",";
    });
    //ES6
    additionalPremiumRate = additionalPremiumRate.replace(/[,.]/g, m =>
      m === "," ? "." : ","
    );

    this.additionalPremium = this.sumInsured * (additionalPremiumRate / 100);

    console.log(event.target);
    this.subTotalValue = this.additionalPremium + this.netPremium;


    for (let i = 0; i < this.summaryDetails.scopeTaxDtoList.length; i++) {
      if (this.summaryDetails.scopeTaxDtoList[i].rateType === "PERCENTAGE") {
        this.summaryDetails.scopeTaxDtoList[i].value =
          this.subTotalValue *
          (this.summaryDetails.scopeTaxDtoList[i].rate / 100);
      } else if (this.summaryDetails.scopeTaxDtoList[i].rateType === "AMOUNT") {
        // finalTax += this.subTotalValue + this.summaryDetails.scopeTaxDtoList[i].rate;
      }
    }

    // calulating total amount based on the additional premium rate, for zero and greater, include equal to also
    if (this.additionalPremium >=0) {
      let finalTax = 0;
      for (let i = 0; i < this.summaryDetails.scopeTaxDtoList.length; i++) {
        if (this.summaryDetails.scopeTaxDtoList[i].rateType === "PERCENTAGE") {
          finalTax += this.summaryDetails.scopeTaxDtoList[i].value;
        } else if (
          this.summaryDetails.scopeTaxDtoList[i].rateType === "AMOUNT"
        ) {
          finalTax += this.summaryDetails.scopeTaxDtoList[i].value;
        }
      }

      if (this.summaryDetails.netPremiumRebate != null) {
        this.rebateSubtotalValue = this.subTotalValue * (this.rebateRate / 100);
        if (this.summaryDetails.netPremiumRebate == true) {
          this.totalValue = (this.subTotalValue - this.rebateSubtotalValue) + finalTax;
        } else {
          this.rebateTaxValue = finalTax * (this.rebateRate / 100);
          this.totalValue = (this.subTotalValue - this.rebateSubtotalValue) + (finalTax - this.rebateTaxValue);
        }

      } else {
        this.totalValue = this.subTotalValue + finalTax;
      }
    } else {
      this.totalValue = this.summaryDetails.totalAmount;
    }
  }

  askForLcText(): void {
    if (this.lcChecked) {
      this.lcTextModal.show();
    } else {
      this.hideLCText();
    }
  }

  ruleFailMessageg(): void {
    if( this.ruleFailedModal){
      this.ruleFailedModal.show();
    }
  }
  hideFailMessage(): void {
    this.ruleFailedModal.hide();
    $(document.body).removeClass("modal-open");
    
    if(this.isVesselNameOrImoMandatoryEnabled && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselUnknown &&  this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.displayImoNumber === 'NA' && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.displayVesselName === 'NA') {
      this.showVesselNameImoWarningModal();
    } else if(!this.isVesselNameOrImoMandatoryEnabled && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselUnknown && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName) {
      this.showVesselNameImoWarningModal();
    }
  }

  checkRulesRedirection(certificateRequestId) {
    if( this.ruleFailedModal){
      this.ruleFailedModal.hide();
      if(this.summaryDetails.typeOfRequest == 'SPECIFIC'){
        this.router.navigate(["/my-declaration/rules-check", certificateRequestId]);
      }else{
        this.router.navigate(["/my-declaration/open-rules-check", certificateRequestId]);
      }
      

    }    
  }

  hideLCText(): void {
    this.lcChecked = false;
    this.lcTextModal.hide();
  }

  hideVesselModel(): void {
    // this.isVesselName = true;
    this.isVesselSubRulePassed = false;
    this.vesselNameModal.hide();
    $(document.body).removeClass("modal-open");
  }

  sendRequestForApproval() {
    let certificateStatus = TdisConstants.CertificateRequestScopeStatus.LC_PENDING_APPROVAL
    if (
      CommonUtils.isNotNil(this.summaryDetails.lcApproval) &&
      CommonUtils.isFalse(this.summaryDetails.lcApproval)
    ) {
      certificateStatus = this.summaryDetails.certificateRequestScopeStatus;
    }
    const data = {
      certificateRequestId: this.downloadObj.scopeId,
      status: certificateStatus,
      lcText: this.lcText
    };
    let url = SERVER_API_URL + "api/certificate-requests/update-status";
    this.certificateService.postData(data, url).subscribe(res => {
      console.log(res);
      console.log(res.body);
      if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
        this.lcTextModal.hide();
        this.jhiAlertService.success(res.body.message);
        if (
          CommonUtils.isNotNil(this.summaryDetails.lcApproval) &&
          CommonUtils.isTrue(this.summaryDetails.lcApproval)
        ) {
          if (
            this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT ||
            this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT_STAFF
          ) {
            this.router.navigateByUrl("/certificate/lc-text");
          }
        }
        // this.router.navigateByUrl('/client-manual-request');
      }
    });
  }
  sendRequestForLcConfirmation() {
    const data = {
      certificateRequestId: this.downloadObj.scopeId,
      status: "PENDING_CERTIFICATE_CONFIRMATION",
      lcText: this.summaryDetails.lcDescription
    };
    let url = this.resourceUrl + "certificate-requests/update-status";
    this.certificateService.postData(data, url).subscribe(res => {
      console.log(res);
      console.log(res.body);
      if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
        this.lcApproved = true;
        this.isGetCertificateEnabled = true;
        this.lcApproveModal.hide();
        // this.router.navigateByUrl('/client-manual-request');
      }
    });
  }

  // IMO check
  openConfirmIMO() {
    this.showConfirmIMO = !this.showConfirmIMO;
  }

  checkIMONumber() {
    this.showCheck = false;
    this.showSpinner = true;
    this.certificateService
      .checkIMONumber(this.vesselImoNumber, this.scopeId)
      .subscribe(
        res => {
          if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
            this.showSpinner = false;
            this.showCheck = true;
            this.showCertificateBasedOnImoNumber = true;
            console.log(res);
            if (res.body) {
              this.getCertificateData();
            }
            //  this.vesselImoNumber = "";
          } else {
            this.showSpinner = false;
            this.showCheck = true;
            if (
              this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT ||
              this.principal.userIdentity.authorities[0] === RoleUtil.Role.CLIENT_STAFF
            ) {
              this.router.navigateByUrl("/certificate/client-manual-request");
            } else {
              this.router.navigateByUrl("/certificate/manual-request");
            }
          }
        },
        (res: HttpErrorResponse) => {
          this.showSpinner = false;
          this.showCheck = false;
          this.vesselImoNumber = "";
          this.jhiAlertService.error("Vessel IMO Number Incorrect", null, null);
        }
      );
  }

  private onError(errorMessage: string) {
    this.jhiAlertService.error("Vessel IMO Number Incorrect", null, null);
  }

  closeReviseCertificateModel() {
    this.revisedConfirmModel.hide();
  }
  confirmReviseCertificateModel() {
    let url = "api/declaration/" + this.certificateRequestId;
    this.bulkDeclarationService.getById(url).subscribe(res => {
      if (CommonUtils.isSame(res.status, MessageConst.SUCCESS)) {
        console.log(res.payload);
        this.stateStorageService.storeBulkCertificateDTO(res.payload);
        this.router.navigateByUrl('/my-declaration/declare-shipment');
      } else {
        this.closeReviseCertificateModel();
        this.jhiAlertService.error("Sorry,  you don't have any active Policy!", null, null);
      }
    });
  }

  uploadCertificate() {
    console.log('UPLOAD CERTIFICATE CALLED......');
    this.router.navigateByUrl('broker-upload-certificate');

  }



  confirmRejectQuotation() {
    const URL =
      this.resourceUrl +
      "reject-certificate-requests/" +
      this.downloadObj.certificateRequestId;
    this.certificateService.getCancelCertificate(URL).subscribe(res => {
      if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
        console.log(res.body.payload);
        this.jhiAlertService.success(
          "Certificate Rejected Successfully",
          null,
          null
        );
        this.summaryDetails.certificateRequestScopeStatus = TdisConstants.CertificateRequestScopeStatus.REJECTED;
        this.rejectQuotationModalClose();
      } else {
      }
    });
  }

  /* reject quotation based on the certificateRequesteId */

  rejectQuotationModalOpen() {
    this.rejectConfirmModel.show();
  }

  rejectQuotationModalClose() {
    this.rejectConfirmModel.hide();
  }

  reviseCertificate() {
    this.revisedConfirmModel.show();
  }
  lcApprove() {
    this.lcApproveModal.show();
  }
  lcNotApproved() {
    this.isGetCertificateEnabled = false;
    this.lcApproveModal.hide();
  }
  confirmLcText() {
    this.sendRequestForLcConfirmation();
  }
  limitTextarea() {
    if (this.lcText.length > 200) {
      this.lcText = this.lcText.slice(0, 200);
      char_removed = 1;
    }
    this.lcTextLength = this.lcText.length;
    var lines = this.lcText.replace(/\r/g, "").split("\n"),
      lines_removed,
      char_removed;
    if (lines.length > 2) {
      lines = lines.slice(0, 2);
      lines_removed = 1;
    }
    if (char_removed || lines_removed) {
      this.lcText = lines.join("\n");
    }
  }

  // (keypress)="spaceNotAllowedAtFirst($event)"
  spaceNotAllowedAtFirst(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode == 32 && event.target.value.length == 0) {
      return false;
    }
  }


  numberOnly(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode === 46) {
      return false;
    } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else {
      return true;
    }
  }

  isVesselInformationSubRulePassed(certificateRequestId: number) {
    this.certificateService.get("api/bulk-vessel-certificate-subrule-passed/" + certificateRequestId).subscribe(data => {
      this.isVesselSubRulePassed = data.body;
      console.warn(this.isVesselSubRulePassed);
    }, err => { })
  }



  // File Preview 
  previewFile(draftObj) {
    let nav :any;
    nav = window.navigator;
    if (draftObj) {
      let base64Data = new Uint8Array(atob(draftObj.preview).split('').map(char => char.charCodeAt(0)));
      let newBlob = new Blob([base64Data], { type: "application/pdf" })
      if (nav && nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      let link = document.createElement('a');
      link.href = data;
      link.title = draftObj.name;
      link.target = "_blank";
      link.click();
    } else {
      console.log(' NO DRAFT CERTIFICATE ');

    }


  }


  // download certificate
  downloadFile(draftObj) {

    if (draftObj) {
      let data = "data:application/pdf;base64," + draftObj.preview;
      this.pdfPath = data;
      const downloadLink = document.createElement("a");
      downloadLink.href = data;
      downloadLink.download = draftObj.name;
      downloadLink.click();
    } else {
      console.log(' NO DRAFT CERTIFICATE ');
    }

  }

  //
  clausesDownloadAll() {
    this.certificateService.findByIdForDownloadAllForClauses(this.certificateScopeId).subscribe(res => {
      let a = document.createElement('a');
      a.href = URL.createObjectURL(res.body);
      let contentDisposition = res.headers.get('Content-Disposition');
      let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }

  clausesDownloadAllFile() {
    let downloadClauseExtesnion = new DownloadClauseExtesnion();
    downloadClauseExtesnion.id = this.certificateScopeId;
    downloadClauseExtesnion.idList = this.clauseIdArray;
    this.bulkDeclarationService.getClauseZip(downloadClauseExtesnion, this.certificateScopeId).subscribe(res => {
      console.log(res.body)
      if(res.body.size>30) {
        let a=document.createElement('a');
        a.href = URL.createObjectURL(res.body);
        let contentDisposition = res.headers.get('Content-Disposition');
        let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        this.toastr.error("Clauses file not found");
      }
  
    }
    // ,
    // (res: any) => {
    //   this.jhiAlertService.error("Clauses file not found", null, null);
    // }
  );
  }

  //
  extensionsDownloadAllFile() {
    let downloadClauseExtesnion = new DownloadClauseExtesnion();
    downloadClauseExtesnion.id = this.certificateScopeId;
    downloadClauseExtesnion.idList = this.extensionIdArray;
    this.bulkDeclarationService.getExtensionZip(downloadClauseExtesnion, this.certificateScopeId).subscribe(res => {
      console.log(res.body.size)
      if(res.body.size > 30){
      let a = document.createElement('a');
      a.href = URL.createObjectURL(res.body);
      let contentDisposition = res.headers.get('Content-Disposition');
      let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }else {
      this.jhiAlertService.error("Extensions file not found",null,null);
    }
    }
    // ,(res: any) => {
          //   this.jhiAlertService.error("Extensions file not found", null, null);
    // }
  );

  }

  openScopeClause(scopeClause: any) {
    if (scopeClause.fileDTO) {
      if (scopeClause.fileDTO.fileId) {
        this.clauseExtensionMySuffixService.downloadFileService(scopeClause.fileDTO.fileId).subscribe(res => {
          const data = window.URL.createObjectURL(res);
          let link = document.createElement('a');
          link.href = data;
          link.target = "_blank";
          link.click();
        })
      }
    }
  }

  openScopeExtension(ext) {
    if (ext.fileDTO) {
      if (ext.fileDTO.fileId) {
        this.clauseExtensionMySuffixService.downloadFileService(ext.fileDTO.fileId).subscribe(res => {
          const data = window.URL.createObjectURL(res);
          let link = document.createElement('a');
          link.href = data;
          link.target = "_blank";
          link.click();
        })
      }
    }
  }




  setClauseForDownload(scopeClause: any, index) {
    let indexPosition;
    indexPosition = this.clauseIdArray.findIndex(obj => obj === scopeClause.clauseExtensionId);

    console.log("scopeClause.clauseExtensionId",scopeClause.clauseExtensionId);
    console.log("item", indexPosition);

    if (indexPosition !== -1) {
      this.clauseIdArray.splice(indexPosition, 1);
    } else {
      if (scopeClause.clauseExtensionId) {
        this.clauseIdArray.push(scopeClause.clauseExtensionId);
      }
    }
    console.log("array", this.clauseIdArray);
  }

  setExtensionForDownload(scopeExtesnion: any, index) {
    let indexPosition;
    indexPosition = this.extensionIdArray.findIndex(id => id === scopeExtesnion.clauseExtensionId);
    console.log("item", indexPosition);

    if (indexPosition !== -1) {
      this.extensionIdArray.splice(indexPosition, 1);
    } else {
      if (scopeExtesnion.clauseExtensionId) {
        this.extensionIdArray.push(scopeExtesnion.clauseExtensionId);
      }
    }
    console.log("array", this.extensionIdArray);
  }


  /**
   * 
   */

  confirmCerificateModalOpen() {
    this.confirmCerificateModal.show();
  }

  confirmCerificateModalhide() {
    this.confirmCerificateModal.hide();
  }

  confirmCerificate() {
    this.bulkDeclarationService.getBy('/bulk-confirm-certificate/' + this.certificateRequestId).subscribe(res => {
      if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
        this.confirmCerificateModal.hide();
        this.jhiAlertService.success("Confirmed Declaration Successfully",null,null );
        this.getCertificateData();
      } else {
        // this.isCertificatedCancelled = false;
      }
    });
  }

  rejectCerificate() {
    this.bulkDeclarationService.getBy('/bulk-reject-certificate/' + this.certificateRequestId).subscribe(res => {
      if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
        this.rejectConfirmModel.hide();
        this.jhiAlertService.success("Rejected Declaration Successfully", null, null );
        // this.isCertificatedCancelled = true;
        this.getCertificateData();
      } else {
        // this.isCertificatedCancelled = false;
      }
    });
  }

  cancelCertificate() {
    this.bulkDeclarationService.getBy('/bulk-cancel-certificate/' + this.certificateRequestId).subscribe(res => {
      if (CommonUtils.isSame(res.body.status, MessageConst.SUCCESS)) {
        this.cancelCerificateModal.hide();
        this.jhiAlertService.success(
          "Cancelled Declaration Successfully",
          null,
          null
        );
        this.isCertificatedCancelled = true;
        this.getCertificateData();
      } else {
        this.isCertificatedCancelled = false;
      }
    });
  }


  getState() {
    let shippingDetail=this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO;
    if(shippingDetail.isPolUnknown&&shippingDetail.polPortCountry) {
      let countries=[];
      this.countryService.query().subscribe(c => countries=c.body);  // getting countries
      
      if(shippingDetail.polPortCountryIso2=='US') {
        let usCon=countries.find(cn => cn.isoTwo=='US');
        if(CommonUtils.isNotNil(usCon)) {
          this.countryService.getStatesByCountryId(usCon.id).subscribe(res => {
            let usState=res.body.find(s => s.abbreviation==shippingDetail.polStateAbbreviation);
            if(CommonUtils.isNotNil(usState)) {
              this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.polStateAbbreviation=usState.name;
            }
          });
        }
      }
      if(shippingDetail.podPortCountryIso2=='US') {
        let usCon=countries.find(cn => cn.isoTwo=='US');
        if(CommonUtils.isNotNil(usCon)) {
          this.countryService.getStatesByCountryId(usCon.id).subscribe(res => {
            let usState=res.body.find(s => s.abbreviation==shippingDetail.podStateAbbreviation);
            if(CommonUtils.isNotNil(usState)) {
              this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.podStateAbbreviation=usState.name;
            }
          });
        }
      }
    }
  }
  isPremiumCalculationDisable:boolean;
    checkPremiumCalculationPermission(){
        this.principal.checkPremiumCalculationAccessForUser().then(res =>{
            if(res){
                console.log("checkPremiumCalculationPermission if" , res);
                this.isPremiumCalculationDisable= false;
            }else{
                console.log("checkPremiumCalculationPermission else" , res);
                this.isPremiumCalculationDisable= true;
            }
        });
    }

    isFirstClassVesselChecked: boolean;
    addFirstClassVesselName(event: any) {
      this.isFirstClassVesselChecked = event.target.checked;
      this.clearWrongImoMsg();
      // if(this.isFirstClassVesselChecked) {
      //   this.isVesselName = null;
      //   this.summaryDetails.certificateRequestDTO.isFirstClassVessel = this.isFirstClassVesselChecked;
      //   // this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isFirstClassVessel = this.isFirstClassVesselChecked;
      //   this.summaryDetails.certificateRequestDTO.isFirstClassVessel = this.isFirstClassVesselChecked;
      //   this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
      //   this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = null;
      // } else {
      //   this.isVesselName = false;
      //   this.summaryDetails.certificateRequestDTO.isFirstClassVessel = this.isFirstClassVesselChecked;
      //   // this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isFirstClassVessel = this.isFirstClassVesselChecked;
      //   this.summaryDetails.certificateRequestDTO.isFirstClassVessel = this.isFirstClassVesselChecked;
      //   this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
      //   this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = null;
      // }
      this.summaryDetails.certificateRequestDTO.isFirstClassVessel = this.isFirstClassVesselChecked;
      if(this.summaryDetails.certificateRequestDTO.isFirstClassVessel) {
        this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
        this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = null;
        this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber = null;
        this.vesselImoOrNameOrUnknownValue = "unknown";
      }
      console.warn(this.summaryDetails.certificateRequestDTO.isFirstClassVessel);

    }

  page = 0;
  // size = 20;
  size = 50;
  private isApiCalled:boolean = true;
  private vesselDataLoaded: boolean = false;
  vesselNameAndImoNumbers = [];
  getImoNumberData() {
    ///vessel-informations-imo
    if (this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName) {
      this.page = 0;
      // this.size = 20;
      this.size = 50;
      this.vesselNameAndImoNumbers = [];
      this.getImoNumberDataPageable(this.page,this.size,false);
      // if(this.ihsTotalCount && this.ihsTotalCount > this.size) {
      //   this.getImoNumberDataPageable(this.page,this.size,false);
      // } else {
      //   return;
      // }
      this.vesselDataLoaded = false;
      this.isApiCalled = true;

    }
  }

  ihsTotalCount: number = 0;
  getImoNumberDataPageable(page:number,size:number,flag:boolean){
    
    this.vesselInformationMySuffixService.post("ihs-vessel-informations-detail/?page="+page+"&size="+size,{name:this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName}).subscribe(res=>{
      let body = res.body;
      if(res && res.headers) {
        const xTotalCount = res.headers.get('X-Total-Count');
        if(typeof xTotalCount === 'string') {
          this.ihsTotalCount = parseInt(xTotalCount);
        } else {
          this.ihsTotalCount = xTotalCount;
        }
      }
      if(body && body.length>0){
        this.vesselNameAndImoNumbers = [...this.vesselNameAndImoNumbers, ...body];
      }else{
        this.vesselDataLoaded = true;
      }
      
      if(flag){
        this.isApiCalled = true;
      }
    },err=>{});
    }

    vesselNameIndexTrack(index:number){
      return index;
    }

    isImoSelected: boolean;
    changeImoNumber(imoName, imoNumber) {
      console.warn(imoName, imoNumber);

      // this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = event.target.value;
      // this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = imoName;
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = imoNumber;
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.imoNumber = imoNumber
      this.isImoSelected = true;
      

    }

    replaceNumberFromEnd(str:string){
      if(str == undefined)return "";
      let s = str.replace(/[\d.-]/g, '');
      return s;
    }
    
    yearOfBuild(date){
      if(date && date.length>4){
        return date.substring(0,4);
      }
      return date;
    }

    onImoSubmit() {
      // this.vesselNameImoModal.hide();
      this.hideVesselNameDataModal();
      this.onSubmit();
    }

    onCancelVesselModel(){
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = null;
      // this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isFirstClassVessel = false;
      this.summaryDetails.certificateRequestDTO.isFirstClassVessel = false;
      this.hideVesselNameDataModal();
      this.showVesselNameImoModal();
    }

    hideVesselNameDataModal() {
      // this.vesselNameImoAdded();
      this.isImoSelected = false;
      this.vesselNameDataModal.hide();
      $(document.body).removeClass("modal-open");
    }

    showVesselNameImoModal()  {
      this.vesselNameImoModal.show();
    }

    onVesselModelScroll(){
      // this.scrollContainer = this.scrollFrame.nativeElement; 
      if(this.isApiCalled && !this.vesselDataLoaded){
        console.log("scroll near to bottom");
        this.isApiCalled = false;
        this.page ++;
        if(this.ihsTotalCount && this.ihsTotalCount > this.size) {
          this.getImoNumberDataPageable(this.page,this.size,true);
        } else {
          return;
        }
      }
    }

    hideVesselNameImoModal()  {
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = null;
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber = null;
      console.warn('test');
      this.vesselNameImoModal.hide();
      this.clearWrongImoMsg();
      this.isVesselSubRulePassed = false;
      $(document.body).removeClass("modal-open");
    }

    trimField(event){
      if (event.target.value) {
          event.target.value = event.target.value.trim()
      }
    }

    removeImoNumber() {
      this.clearWrongImoMsg();
      this.isImoSelected = false;
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = undefined;
      this.summaryDetails.certificateRequestDTO.isFirstClassVessel = false;
      if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName === TdisConstants.VesselName.FIRST_CLASS_VESSEL) {
        this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = undefined;
      }
      this.vesselImoOrNameOrUnknownValue = "name";
    }

    trimVesselImo(event) {
      if (event.target.value.length >= 7) {
        this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber .trim();
        return false;
      }
  
    }

  maxLength: any;
  checkVesselImoLength(event) {

    if (this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber) {
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber.trim();
    }

    if (event.target.value.length >= 7) {
      this.maxLength = 7;
      return false;
    }
  }


    onPasteVesselImo(event) {
      let clipboardData = event.clipboardData;
      let pastedText = clipboardData.getData('text');
      let regexp = new RegExp(/^[0-9]+$/);
      console.log(regexp.test(pastedText));
      if (regexp.test(pastedText)) {
        if (pastedText.length > 7) {
          this.maxLength = 7;
          return false;
        }
        //  this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber  = pastedText.trim();
        return true;
      } else {
        return false;
      }
    }

    removeVesselName() {
      this.isImoSelected = true;
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = undefined;
      this.summaryDetails.certificateRequestDTO.isFirstClassVessel = false;
      if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName === TdisConstants.VesselName.FIRST_CLASS_VESSEL) {
        this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = undefined;
      }
      this.vesselImoOrNameOrUnknownValue = "imo";
    }

    onSubmit() {

      // if IMO number contains 'A123456', validation
      const IMO_NUMBER = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber;
      if(IMO_NUMBER && !CommonUtils.isNumber(IMO_NUMBER)) {
        this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
        this.vesselNameImoModal.hide();
        this.clearWrongImoMsg();
        this.jhiAlertService.error("The IMO should contain numbers only.");
        return;
      }

      if(CommonUtils.isTrue(this.summaryDetails.certificateRequestDTO.isFirstClassVessel)){ // for first class vessel
        console.warn('test');
        this.vesselNameImoAdded();
        // this.vesselNameImoModal.hide();
        this.clearWrongImoMsg();
      }else{
            // for vessel name
          if(!CommonUtils.isNil(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName) && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName.length > 0 && CommonUtils.isNil(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber)) {
            console.warn('test');
            if (this.vesselNameAndImoNumbers.length > 0) {
              console.warn('test');
              if (this.isImoSelected == undefined || this.isImoSelected == false) {
                console.warn('test');
                this.vesselNameDataModal.show();
                $(".width-10 input[type='radio']").prop('checked', false)
                // move scroll bar top of the div
                setTimeout(() => {
                  let myDiv = document.getElementById('focusDiv');
                  myDiv.scrollTop = 0;
                }, 1000);
                console.warn('test');
                return;
              }
              console.warn('test');
            }
  
            if(this.vesselNameAndImoNumbers && this.vesselNameAndImoNumbers.length === 0) {
              console.warn('test');
              this.vesselNameImoAdded();
              this.vesselNameImoModal.hide();
              this.clearWrongImoMsg();
            } else {
              console.warn('test');
              this.vesselNameImoModal.show();
            }
          }
          else if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber) { // for imo number
            console.warn('test');
            this.vesselNameImoAdded();
            // this.vesselNameImoModal.hide();
        }
      }
      

      // if ((this.principal.userIdentity.authorities[0] !== 'CLIENT_STAFF' && this.principal.userIdentity.authorities[0] !== 'CLIENT') && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber == undefined && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName.length > 0) {
      //   console.warn('test');
      //   if (this.vesselNameAndImoNumbers.length > 0) {
      //     console.warn('test');
      //     if (this.isImoSelected == undefined || this.isImoSelected == false) {
      //       console.warn('test');
      //       this.vesselNameDataModal.show();
      //       $(".width-10 input[type='radio']").prop('checked', false)
      //       // move scroll bar top of the div
      //       setTimeout(() => {
      //         let myDiv = document.getElementById('focusDiv');
      //         myDiv.scrollTop = 0;
      //       }, 1000);
      //       console.warn('test');
      //       return;
      //     }
      //     console.warn('test');
      //   }
      //   console.warn('test');
      //   if(this.vesselNameAndImoNumbers && this.vesselNameAndImoNumbers.length === 0) {
      //     console.warn('test');
      //     this.vesselNameImoAdded();
      //     this.vesselNameImoModal.hide();
      //   } else {
      //     console.warn('test');
      //     this.vesselNameImoModal.show();
      //   }

      // } else if ((this.principal.userIdentity.authorities[0] === 'CLIENT_STAFF' || this.principal.userIdentity.authorities[0] === 'CLIENT') && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber == undefined && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName.length > 0) {
      //   console.warn('test');
      //   if (this.vesselNameAndImoNumbers.length > 0) {
      //     console.warn('test');
      //     if (this.isImoSelected == undefined || this.isImoSelected == false) {
      //       console.warn('test');
      //       this.vesselNameDataModal.show();
      //       $(".width-10 input[type='radio']").prop('checked', false)
      //       // move scroll bar top of the div
      //       setTimeout(() => {
      //         let myDiv = document.getElementById('focusDiv');
      //         myDiv.scrollTop = 0;
      //       }, 1000);
      //       console.warn('test');
      //       return;
      //     }
      //     console.warn('test');
      //   }
      //   console.warn('test');
      //   if(this.vesselNameAndImoNumbers && this.vesselNameAndImoNumbers.length === 0) {
      //     console.warn('test');
      //     this.vesselNameImoAdded();
      //     this.vesselNameImoModal.hide();
      //   } else {
      //     console.warn('test');
      //     this.vesselNameImoModal.show();
      //   }

      // } else if((this.principal.userIdentity.authorities[0] !== 'CLIENT_STAFF' && this.principal.userIdentity.authorities[0] !== 'CLIENT') && this.summaryDetails.certificateRequestDTO.isFirstClassVessel) {
      //   console.warn('test');
      //   this.vesselNameImoAdded();
      //   this.vesselNameImoModal.hide();
      // } else if((this.principal.userIdentity.authorities[0] === 'CLIENT_STAFF' || this.principal.userIdentity.authorities[0] === 'CLIENT') && this.summaryDetails.certificateRequestDTO.isFirstClassVessel && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory) {
      //   console.warn('test');
      //   this.vesselNameImoAdded();
      //   this.vesselNameImoModal.hide();
      // } else if((this.principal.userIdentity.authorities[0] !== 'CLIENT_STAFF' && this.principal.userIdentity.authorities[0] !== 'CLIENT') && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber) {
      //   console.warn('test');
      //   this.vesselNameImoAdded();
      //   this.vesselNameImoModal.hide();
      // } else if((this.principal.userIdentity.authorities[0] === 'CLIENT_STAFF' || this.principal.userIdentity.authorities[0] === 'CLIENT') && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber) {
      //   console.warn('test');
      //   if(!this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory) {
      //     this.vesselNameImoAdded();
      //     this.vesselNameImoModal.hide();
      //   } else if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory) {
      //     this.vesselNameImoAdded();
      //     this.vesselNameImoModal.hide();
      //   }
      // }

      
      // else if (this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber == undefined && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isFirstClassVessel && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName.length > 0 && this.vesselNameAndImoNumbers && this.vesselNameAndImoNumbers.length === 0) {
      //   console.warn('test');
      //   this.vesselNameImoAdded();
      //   this.hideVesselNameImoModal();
      // }


    }

  isVesselNameProvided: boolean = false;
  vesselNameImoAdded() {
    const certificate_request_id: number = this.summaryDetails.certificateRequestId;

    this.vesselUnknownDto=new VesselUnknownDTO();
    this.vesselUnknownDto.vesselName = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName;
    this.vesselUnknownDto.imoNumber = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber;
    this.vesselUnknownDto.isFirstClassVesselSelected=this.summaryDetails.certificateRequestDTO.isFirstClassVessel;
    this.vesselUnknownDto.voyageNumber = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber;
 
    if(RoleUtil.isClient(this.principal.authority)) { // for client / staff
 
       if( CommonUtils.isTrue(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory)) {
         this.vesselUnknownDto.isFirstClassVesselSelected=false;
      }
      else if(CommonUtils.isTrue(this.summaryDetails.certificateRequestDTO.isFirstClassVessel)) { // first class vessel will be true only if its not mandatory and selected
        this.vesselUnknownDto.isFirstClassVesselSelected=true;
       }
    } else { // for roles other than client/staff
      if(CommonUtils.isTrue(this.summaryDetails.certificateRequestDTO.isFirstClassVessel)) {
        this.vesselUnknownDto.isFirstClassVesselSelected=true;
      } else {
        this.vesselUnknownDto.isFirstClassVesselSelected=false;
      }
    }
 
    if(CommonUtils.isTrue(this.vesselUnknownDto.isFirstClassVesselSelected)) {
      this.vesselUnknownDto.vesselName = null;
      this.vesselUnknownDto.imoNumber = null;
    }
 
    // if first class is not selected and vessel imo and name both also null then raise error
    if(CommonUtils.isFalse(this.vesselUnknownDto.isFirstClassVesselSelected) &&(CommonUtils.isNil(this.vesselUnknownDto.vesselName)&&CommonUtils.isNil(this.vesselUnknownDto.imoNumber))) {
      this.jhiAlertService.error("Please provide valid IMO number or Vessel name");
      return;
    }
    
    // if((this.principal.userIdentity.authorities[0] !== 'CLIENT_STAFF' && this.principal.userIdentity.authorities[0] !== 'CLIENT') && this.summaryDetails && this.summaryDetails.certificateRequestDTO && !this.summaryDetails.certificateRequestDTO.isFirstClassVessel) {
    //   this.vesselUnknownDto.vesselName = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName;
    //   this.vesselUnknownDto.imoNumber = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber;
    //   this.vesselUnknownDto.isFirstClassVesselSelected = false;
    // } else if((this.principal.userIdentity.authorities[0] === 'CLIENT_STAFF' || this.principal.userIdentity.authorities[0] === 'CLIENT') && this.summaryDetails && this.summaryDetails.certificateRequestDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory) {
    //   this.vesselUnknownDto.vesselName = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName;
    //   this.vesselUnknownDto.imoNumber = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber;
    //   this.vesselUnknownDto.isFirstClassVesselSelected = false;
    // } else if ((this.principal.userIdentity.authorities[0] !== 'CLIENT_STAFF' && this.principal.userIdentity.authorities[0] !== 'CLIENT') && this.summaryDetails && this.summaryDetails.certificateRequestDTO.isFirstClassVessel) {
    //   this.vesselUnknownDto.isFirstClassVesselSelected = this.summaryDetails.certificateRequestDTO.isFirstClassVessel;
    // } else if ((this.principal.userIdentity.authorities[0] === 'CLIENT_STAFF' || this.principal.userIdentity.authorities[0] === 'CLIENT') && this.summaryDetails && this.summaryDetails.certificateRequestDTO.isFirstClassVessel && !this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselNameOrImoMandatory) {
    //   this.vesselUnknownDto.isFirstClassVesselSelected = this.summaryDetails.certificateRequestDTO.isFirstClassVessel;
    // }
    

    if(this.isPopupBeingOpenedFromAction) {  
      this.bulkDeclarationService.vesselNameImoUnknown(certificate_request_id, this.vesselUnknownDto).subscribe((res: any) => {
        if(res && res.body && res.body.payload && res.body.payload.statusCodeValue === 200) {

          this.clearWrongImoMsg();
          this.vesselNameImoModal.hide();
          $(document.body).removeClass("modal-open");

          this.getCertificateData();
          // this.ruleFaileDetail();
        }
        // this.isVesselNameProvided = true;
        // if(this.isVesselNameProvided) {
        //   localStorage.setItem("isVesselNameProvided", JSON.stringify(this.isVesselNameProvided));
        // }
        // this.vesselNameImoModal.hide();
      }, err => {
        this.wrongImoErrorMessage = err.error.message;
        // this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveyanceNumber = null;
        // console.warn(this.wrongImoErrorMessage);
      });
    } else {
      this.sendAdditionalPremiumRate();
    }
  }

  hideVesselNameNotProvidedModal(){
    this.showChildModal();
    this.vesselNameNotProvidedModal.hide();
  }

  showVesselNameNotProvidedModal(){
    this.vesselNameNotProvidedModal.show();
  }

  vesselNameNotAddedAlert() {
    if (
      this.summaryDetails &&
      this.summaryDetails.certificateRequestDTO &&
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO &&
      !this.summaryDetails.certificateRequestDTO.isVesselNameAddedManually
    ) {
      this.showVesselNameNotProvidedModal();
    } else {
      this.hideVesselNameNotProvidedModal();
    }
  }

  addVesselNameImo() {
    
    if(this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.meansOfConveynace===TdisConstants.MeansOfConveyance.VESSEL && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isVesselUnknown) {
      this.vesselNameImoModal.show();
      // this.isVesselSubRulePassed=true;
      return;
    } else {
      console.warn('test');
      this.vesselNameImoModal.hide();
      this.clearWrongImoMsg();
    }

    
  }

  isPopupBeingOpenedFromAction: boolean = true;

  // it will get called from action
  openVesselNameImoWishListPopupFromAction() {
    this.isPopupBeingOpenedFromAction = true;
    if(this.summaryDetails && this.summaryDetails.certificateRequestDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName === TdisConstants.VesselName.FIRST_CLASS_VESSEL) {
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = null;
      if(RoleUtil.isClient(this.principal.authority) && this.isVesselNameOrImoMandatoryEnabled) {
        this.vesselImoOrNameOrUnknownValue = "name";
      } else {
        this.vesselImoOrNameOrUnknownValue = "unknown";
      }
    }
    // setting voyageNumber as null
    this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber = null;
    this.addVesselNameImo();
  }
  
  openVesselNameImoWishListPopupFromAdditional() {
    this.isPopupBeingOpenedFromAction = false;
    if(this.summaryDetails && this.summaryDetails.certificateRequestDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName === TdisConstants.VesselName.FIRST_CLASS_VESSEL) {
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = null;
      if(RoleUtil.isClient(this.principal.authority) && this.isVesselNameOrImoMandatoryEnabled) {
        this.vesselImoOrNameOrUnknownValue = "name";
      } else {
        this.vesselImoOrNameOrUnknownValue = "unknown";
      }
    }
    // setting voyageNumber as null
    this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber = null;
    this.sendAdditionalPremiumRate()
  }

  showVesselNameImoWarningModal(){
    if((!this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.isImoAvailable && !this.isVesselNameAddedManually) && !this.isVesselNameProvided && (this.summaryDetails.certificateRequestScopeStatus !== TdisConstants.CertificateRequestScopeStatus.DECLARED && this.summaryDetails.certificateRequestDTO.certificateStatus != TdisConstants.CertificateRequestScopeStatus.REQUEST_REVISED && this.summaryDetails.certificateRequestScopeStatus !== TdisConstants.CertificateRequestScopeStatus.CERTIFICATE_CANCELLED && this.summaryDetails.certificateRequestScopeStatus !== TdisConstants.CertificateRequestScopeStatus.REJECTED && this.summaryDetails.certificateRequestScopeStatus !== TdisConstants.CertificateRequestScopeStatus.REQUEST_FAILED)) {
      this.vesselNameImoWarningModal.show();
    }
  }

  hideVesselNameImoWarningModal(){
    this.vesselNameImoWarningModal.hide();
    $(document.body).removeClass("modal-open");
  }

  isVesselNameOrImoMandatoryEnabled: boolean = false;

  checkForVesselNameOrImoMandatoryEnabled(){
    this.certificateService.findVesselNameOrImoMandatoryEnabled().subscribe((res)=>{
      if(res){
        this.isVesselNameOrImoMandatoryEnabled = res.body.payload ;
      }
    });
  }

  clearWrongImoMsg(): void {
    if(this.wrongImoErrorMessage && this.wrongImoErrorMessage.length > 0)  {
      this.wrongImoErrorMessage = null;
    }
  }

  isVoyageNoEnabled: boolean = false;
  trimVoyage(event) {
    if (this.summaryDetails && this.summaryDetails.certificateRequestDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO && this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber) {
      this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber = this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.voyageNumber.trim();
    }
  }

  checkForVoyegaNumberEnabled(){
    this.certificateService.findVoyageNumberEnabled().subscribe((res)=>{
      if(res){
        this.isVoyageNoEnabled = res.body.payload;
      }
    });
  }

}
